<template lang="pug">
.footerStandartComponent
  .row._1
    ui-logo
    .contacts(v-if="isHomepage")
      .title Контакты
      .links
        a(href="mailto:vopros@prosv.ru") vopros@prosv.ru
        a(href="tel:+7495789340") +7 (495) 789-30-40
    .linkIconsWrapper(v-if="!isHomepage")
      .linkIcons
        .linkIcon.support(@click="onTutorialButtonClick")
          .icon
            ui-svg-icon(
              name="question-mark"
              original-colors
            )
          .text Инструкция
        .linkIcon.tutorial(@click="onSupportButtonClick")
          .icon
            ui-svg-icon(
              name="letter"
              original-colors
            )
          .text Поддержка
  .row._2
    .copyright © {{ year }}, ГК «Просвещение». Все&nbsp;права&nbsp;защищены.
    footer-agreement
    .thesis
      .text Made by
      ui-image.image(image-url="assets/images/thesis.svg")
</template>

<script>
import { computed, inject } from 'vue'
import FooterAgreement from './FooterItems/FooterAgreement'
import AppTutorial from '@/components/AppTutorial/AppTutorial'
import SupportForm from '@/components/Forms/SupportForm/SupportForm'
import moment from 'moment'
import { useRoute } from 'vue-router'

export default {
  components: {
    FooterAgreement,
    AppTutorial
  },
  setup () {
    const store = inject('store')
    const route = useRoute()
    const isHomepage = computed(() => route.name === 'Home')

    const onTutorialButtonClick = () => {
      store.modalQueue.push({
        key: 'apptutorial',
        component: AppTutorial
      })
    }
    const onSupportButtonClick = () => {
      store.modalQueue.push({
        key: 'supportform',
        component: SupportForm
      })
    }

    const year = computed(() => moment().format('YYYY'))

    return {
      year,
      onTutorialButtonClick,
      onSupportButtonClick,
      isHomepage
    }
  }
}
</script>

<style lang="sass" scoped>
.footerStandartComponent
  max-width: $appMaxWidth
  background-color: $cWhite
  padding: 7*$u $appSidePaddingDesktop
  min-height: 70px
  margin: 0 auto
  @include gap(6*$u 12*$u)
  @include font('t14-regular')
  line-height: 5*$u
  white-space: nowrap
  @media (max-width: $padWidth)
    padding: 4*$u $appSidePaddingMobile
    white-space: initial

  .row
    display: flex
    align-items: center
    @include gap(10*$u)
    @media (max-width: $XXXLWidth)
      @include gap(7*$u)
    @media (max-width: $padWidth)
      flex-direction: column
      align-items: flex-start
      @include gap(5*$u, 'column')

    &:not(:last-child)
      padding-bottom: 6*$u
    &:not(:first-child)
      padding-top: 6*$u

    > *
      &:first-child
        width: 350px
        margin-right: initial !important
        @media (max-width: $LWidth)
          width: initial
      &:not(:last-child)
        margin-right: auto
        @media (max-width: $padWidth)
          margin-right: initial
      &:last-child
        @media (max-width: $padWidth)
          margin-left: initial
    &._1
    &._2
      border-top: 1px solid $cBackground
      @media (max-width: $XXXLWidth)
        flex-wrap: wrap

  .linkIconsWrapper

  .linkIcons
    display: flex
    margin-left: -15*$u
    > *
      margin-left: 15*$u

  .linkIcon
    display: flex
    align-items: center
    color: $cDarkBlue
    font-weight: 600
    @include font('t16-regular')
    cursor: pointer
    .text
      margin-left: $u

  .tutorial
    .icon
      width: 22px
      height: 15px
      flex: 0 0 22px

  .support
    .icon
      width: 5*$u
      height: 5*$u
      flex: 0 0 5*$u

  .contacts
    &:last-child
      margin-left: initial
    .title
      @include font('t18-demibold')
    .links
      display: flex
      @include gap(5*$u)
      @include font('t16-regular')
      @media (max-width: $XXSWidth)
        flex-direction: column
        @include gap($u, 'column')

  .copyright

  .link
    position: relative
    cursor: pointer
    &::after
      content: ' '
      position: absolute
      bottom: -1px
      left: 0
      width: 100%
      height: 1px
      background-color: $cBlue

  .thesis
    display: flex
    align-items: center
    .text
      margin-right: $u
    .image
      display: inline-block
      width: 12*$u
      height: 3*$u
</style>
